import {computed, Injectable, signal} from '@angular/core';
import {TypologyLabel} from '@modules/activities/core/typologies/typology.label';

const SUPPORTED_TYPOLOGIES: TypologyLabel[] = [
    TypologyLabel.multipleChoiceUniqueAnswer,
    TypologyLabel.multipleChoice,
    TypologyLabel.trueFalse,
    TypologyLabel.sortMat,
    TypologyLabel.textMatching,
    TypologyLabel.shortAnswer,
    TypologyLabel.fillBlanks,
    TypologyLabel.missing,
    TypologyLabel.multimedia,
    TypologyLabel.recording,
    TypologyLabel.external
]

@Injectable({
    providedIn: 'root',
})
export class LessonEditionConfigurationService {

    public readonly allowedTypologies = signal([...SUPPORTED_TYPOLOGIES]);
    public readonly disallowedTypologies = computed(() =>
        Object.values(TypologyLabel).filter(typology => !this.allowedTypologies().includes(typology))
    );

    public allowTypology(typology: TypologyLabel): void {
        if (!SUPPORTED_TYPOLOGIES.includes(typology)) {
            throw new Error(`Typology ${typology} is not supported in the activity edition module.`);
        }

        if (!this.allowedTypologies().includes(typology)) {
            this.allowedTypologies.update((current) => [...current, typology]);
        } else {
            console.warn(`Typology ${typology} is already allowed.`);
        }
    }

    public disallowTypology(typology: TypologyLabel): void {
        if (this.allowedTypologies().includes(typology)) {
            this.allowedTypologies.update((current) => current.filter(t => t !== typology));
        } else {
            console.warn(`Typology ${typology} is not currently allowed.`);
        }
    }
}
